export default __webpack_public_path__ + "static/media/closet5-after1-1920w.56cbebe4.webp";